/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3FormInput from '@Uilib/h3FormInput';
import SellerActions from '@Actions/sellerActions';
import UserActions from '@Actions/userActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import './style.scss';
import { Select } from 'antd';
import Helpers from '@Apis/helpers';
import SelectDepartment from '@Components/Common/SelectDepartment';
import PRZSelect from '../../../Common/UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
class AddUser extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      name: '',
      roleList: [],
      departmentsList: ['Admin', 'Finance', 'Purchase', 'Operations', 'Guest', 'Others'],
    };
  }

  /**
   *
   */
  componentDidMount() {
  }

  /**
   *
   * @param props
   * @param state
   * @return {(*&{roleList: {}})|*}
   */
  static getDerivedStateFromProps(props, state) {
    if (props?.roles?.data && !state.roleList?.length) {
      const roleMapping = {};
      for (let i = 0; i < props?.roles?.data?.length; i++) {
        const currentRole = props?.roles?.data[i];
        // eslint-disable-next-line max-len
        if (roleMapping.hasOwnProperty(props?.roles?.data[i]?.tenant_department_name?.toUpperCase())) roleMapping[props?.roles?.data[i]?.tenant_department_name?.toUpperCase()].push(currentRole);
        else roleMapping[props?.roles?.data[i]?.tenant_department_name?.toUpperCase()] = [currentRole];
      }
      return {
        ...state,
        roleList: roleMapping,
      };
    }
    return state;
  }

  /**
   *
   */
 addUser = () => {
   this.setState({ formSubmitted: true });
   const {
     email, name, role, phone, designation,
   } = this.state;
   const {
     createUser, callback, user, selectedTenant,
   } = this.props;
   if (role && Helpers.validateEmail(email) && Helpers.validatePhoneNumber(phone) && name) {
     const payload = {
       email,
       first_name: name,
       mobile: phone,
       is_active: true,
       tenant_user: [{
         tenant_id: selectedTenant?.tenant_id ? selectedTenant?.tenant_id : user?.tenant_info?.tenant_id,
         tenant_role_id: role,
         designation,
       }],
     };
     createUser(payload, () => callback());
   }
 }

 /**
  *
  * @return {JSX.Element}
  */
 render() {
   const {
     createUserLoading, roles, getRoles, selectedTenant, user,
   } = this.props;
   const {
     name, formSubmitted, email, phone, roleList, role, designation, departmentsList, department,
   } = this.state;

   return (
     <div className="ant-row">
       <div className="ant-col-md-24 ant-col-xs-24">
         <SelectDepartment
           dropdownAlign={{ offset: [-6, 4] }}
           selectedDepartment={department}
           showSearch
           onChange={(value) => {
             this.setState({ department: value?.department_id, role: '', roleId: '' });
             getRoles(selectedTenant?.tenant_id ? selectedTenant?.tenant_id : user?.tenant_info?.tenant_id, value?.tenant_department_id);
           }}
           tenantId={selectedTenant?.tenant_id ? selectedTenant?.tenant_id : user?.tenant_info?.tenant_id}
           containerClassName="orgInputContainer"
           labelClassName="orgFormLabel"
         />

         {formSubmitted && !department && (
           <div className="input-error">
             *Please select department
           </div>
         )}
       </div>
       <div className="ant-col-md-24 ant-col-xs-24">
         <div className="orgInputContainer">
           <div style={{ display: 'flex' }}>
             <label style={{ width: '82%' }} className="orgFormLabel">
               Select Role
               <span style={{ color: 'red' }}>{'  *'}</span>
             </label>
           </div>
           <PRZSelect
             value={role}
             showSearch
             disabled={!department}
             onChange={(selectedRole) => {
               this.setState({ role: selectedRole });
             }}
             showError={formSubmitted && !role}
             errorName="*Please enter role"
             errorClassName="input-error"
           >
             {roles?.data?.length && roles?.data?.map((item) => (
               <Option key={item.tenant_role_id} value={item.tenant_role_id}>
                 {item.tenant_role_name}
               </Option>
             )) }
           </PRZSelect>
         </div>
       </div>
       <div className="ant-col-md-24 ant-col-xs-24">
         <H3FormInput
           name="Name"
           type="text"
           containerClassName="orgInputContainer"
           labelClassName="orgFormLabel"
           inputClassName="gst__input-add-product orgFormInput"
           placeholder=""
           onChange={(event) => this.setState({ name: event.target.value })}
           value={name}
           label="Name"
           required
           showError={formSubmitted && !(name)}
           maxlength="50"
         />
       </div>
       <div className="ant-col-md-24 ant-col-xs-24">
         <H3FormInput
           name="a valid email"
           type="text"
           containerClassName="orgInputContainer"
           labelClassName="orgFormLabel"
           inputClassName="gst__input-add-product orgFormInput"
           placeholder=""
           onChange={(event) => this.setState(
             { email: event.target.value },
           )}
           value={email}
           required
           showError={formSubmitted && !Helpers.validateEmail(email)}
           label="Email"
         />
       </div>
       <div className="ant-col-md-24 ant-col-xs-24">
         <H3FormInput
           name="a valid phone"
           type="text"
           containerClassName="orgInputContainer"
           labelClassName="orgFormLabel"
           inputClassName="gst__input-add-product orgFormInput"
           placeholder=""
           onChange={(event) => this.setState(
             { phone: event.target.value },
           )}
           value={phone}
           required
           showError={formSubmitted && !Helpers.validatePhoneNumber(phone)}
           label="Phone"
         />
       </div>
       <div className="ant-col-md-24 ant-col-xs-24">
         <H3FormInput
           name="Designation"
           type="text"
           containerClassName="orgInputContainer"
           labelClassName="orgFormLabel"
           inputClassName="gst__input-add-product orgFormInput"
           placeholder=""
           onChange={(event) => this.setState(
             { designation: event.target.value },
           )}
           value={designation}
           label="Designation"
         />
       </div>
       <div className="ant-col-md-12" style={{ marginTop: '0.5rem' }}>
         <H3Button
           buttonType={defaultButtonTypes.BLUE_ROUNDED}
           text="Add User"
           onClick={() => this.addUser()}
           isLoading={createUserLoading}
           disabled={createUserLoading}
           style={{
             width: '200px',
             borderRadius: '5px',
             padding: '7px 0px',
             marginLeft: '0',
           }}
         />
       </div>
     </div>

   );
 }
}

const mapStateToProps = ({
  UserReducers, TenantReducers,
}) => ({
  user: UserReducers.user,
  tenants: TenantReducers.tenants,
  roles: UserReducers.roles,
  createUserLoading: UserReducers.createUserLoading,
});
const mapDispatchToProps = (dispatch) => ({

  setCityState: (city, state) => dispatch(SellerActions.setCityState(city, state)),
  getCityState: (pincode) => dispatch(SellerActions.getCityState(pincode)),
  getRoles: (tenantId, tenantDepartmentId) => dispatch(UserActions.getRoles(tenantId, tenantDepartmentId)),
  createUser: (payload, callback) => dispatch(UserActions.createUser(payload, callback)),
});

AddUser.propTypes = {
  user: PropTypes.any,
  createUserLoading: PropTypes.bool,
  callback: PropTypes.any,
  roles: PropTypes.any,
  createUser: PropTypes.func,
  getRoles: PropTypes.func,
  selectedTenant: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AddUser));
